<template>
    <div>
        <br />
        <div id="serviceTypeFormCart" class="form-group">
            <template v-for="(item, key) in serviceTypeFormConfig">
                <component v-bind:is="getFormInputComponent(item)" :item="item" :restaurant="restaurant"></component>
            </template>
        </div>
    </div>
</template>
<script>
    import Input from './Form/Input'
    import Select from './Form/Select'
    import SelectProgrammed from './Form/SelectProgrammed'
    import Date from './Form/Date'
    import Time from './Form/Time'
    import Datetime from './Form/Datetime'
    import Number from './Form/Number'
    import EventBus from '../../../EventBus'

    export default {
        props: [
            'restaurant',
        ],

        components: {
            Input, SelectProgrammed, Select, Date, Time, Datetime, Number
        },

        data () {
            return {
                serviceTypeFormConfig: ((this.restaurant && this.restaurant.service_type) ? _.sortBy(this.restaurant.service_type.config, ['position']) : {}),
            }
        },

        methods: {
            getFormInputComponent(item) {
                let availableInputs = ['Input', 'Select', 'Date', 'Time', 'Number'];
                if (item.key == 'is_programmed') {
                    return 'SelectProgrammed';
                } else {
                    if (_.indexOf(availableInputs, _.capitalize(item.type)) != -1) {
                        return _.capitalize(item.type);
                    } else {
                        return 'Input';
                    }
                }
            },
        },
    }
</script>
